import { render, staticRenderFns } from "./SignActivityGoodsList.vue?vue&type=template&id=351e2543&scoped=true"
import script from "./SignActivityGoodsList.vue?vue&type=script&lang=js"
export * from "./SignActivityGoodsList.vue?vue&type=script&lang=js"
import style0 from "./SignActivityGoodsList.vue?vue&type=style&index=0&id=351e2543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351e2543",
  null
  
)

export default component.exports